export default {"src":"/_next/static/media/plan-icon-2flower-pink.a1d77d1b.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};